import { Authority } from '@/shared/security/authority';

const Register = () => import('@/account/register/register.vue');
const Activate = () => import('@/account/activate/activate.vue');
const ResetPasswordInit = () => import('@/account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('@/account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('@/account/change-password/change-password.vue');
const Settings = () => import('@/account/settings/settings.vue');
const LoginPage = () => import('@/account/login-page/login-page.vue');
const Topbar = () => import('@/core/topbar/topbar.vue');
const Sidebar = () => import('@/core/sidebar/sidebar.vue');

export default [
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/account/activate',
    name: 'Activate',
    component: Activate,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/account/reset/request',
    name: 'ResetPasswordInit',
    component: ResetPasswordInit,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/account/reset/finish',
    name: 'ResetPasswordFinish',
    component: ResetPasswordFinish,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/account/password',
    name: 'ChangePassword',
    components: { default: ChangePassword, Topbar, Sidebar },
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/account/settings',
    name: 'Settings',
    components: { default: Settings, Topbar, Sidebar },
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
];
